module.exports = __webpack_public_path__ + "assets/img/down.555129e6.png";